import { render, staticRenderFns } from "./CarouselChevronIcon.vue?vue&type=template&id=500fc444&scoped=true"
import script from "./CarouselChevronIcon.vue?vue&type=script&lang=js"
export * from "./CarouselChevronIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500fc444",
  null
  
)

export default component.exports